import { render, staticRenderFns } from "./InDesignEditor.vue?vue&type=template&id=7dbf5865&scoped=true"
import script from "./InDesignEditor.vue?vue&type=script&lang=js"
export * from "./InDesignEditor.vue?vue&type=script&lang=js"
import style0 from "./InDesignEditor.vue?vue&type=style&index=0&id=7dbf5865&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dbf5865",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/print-suite/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7dbf5865')) {
      api.createRecord('7dbf5865', component.options)
    } else {
      api.reload('7dbf5865', component.options)
    }
    module.hot.accept("./InDesignEditor.vue?vue&type=template&id=7dbf5865&scoped=true", function () {
      api.rerender('7dbf5865', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/entries/fullscreen/InDesignEditor.vue"
export default component.exports